/**
 * Created by JAVIER on 10/31/2019.
 */
import React from 'react'

import './modalCarousel.css'
import { message } from 'antd'

import photoService from '../services/photo.service'

class BigPhoto extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
        rotation: props.file.rotation % 360 | 0,
    }
  }

  rotate = async () => {
    let newState = {...this.state};
    newState.rotation = (newState.rotation + 90) % 360;
    const rsp = await photoService.saveRotation(this.props.file._id, newState.rotation);
    if ( rsp.rspCode === 'ok') {
        this.setState(newState);
        message.success("rotation saved successfully")
        this.props.file.rotation = newState.rotation
        return newState.rotation;
    }
    else{
        message.error("Error while saving rotation")
        return null;
    }
  }

  reset = async () => {
      const rsp = await photoService.saveRotation(this.props.file._id, 0);
      if ( rsp.rspCode === 'ok') {
          this.setState({rotation: 0});
          message.success("rotation saved successfully")
          return 0;
      }
      else{
          message.success("Error while saving rotation")
          return null;
      }
  }

  getImageUrl = ()=>{
    console.log("this.props.file._id", this.props.file._id);
      return this.props.shared ? `/api/v1/share/photos/image/medium/${this.props.file._id}?token=${this.props.token}`
          : '/api/v1/photos/image/medium/' + this.props.file._id;
  }

  render() {

    console.log('BigPhoto.render...');
    return (
        <div key={this.props.file._id}>
          <img
              className={'rotate'+this.state.rotation}
              src={this.getImageUrl() }
              style={{display: 'block', maxWidth: '852px', maxHeight: '500px', width: 'auto', height: 'auto' }}
          />
        </div>
    )
  }
}

export default BigPhoto;
